export default {
  // all page
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  save: 'Save',
  edit: 'Edit',
  dataIterator: {
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  company: {
    companyDetail: 'Company detail',
    companyName: 'Company name',
    description: 'Description',
    contactEmail: 'Company contact email',
    systemEmail: 'Username/Login email',
    msg1: 'For user login',
    subDomain: 'Sub domain name',
    externalAccess: 'ExternalAccess',
    externalAccessNo: 'No',
    externalAccessYes: 'Yes',
    msg2: 'People outside the organization are inaccessible.',
    msg3: 'People outside the organization have access.',
    Limitation: 'Limitation',
    allowRegister: 'Allow user registration',
    allowRegisterNo: 'No',
    allowRegisterYes: 'Yes',
    msg4: 'Users cannot register themselves.',
    msg5: 'Users can register themselves.',
    registerOption: 'Register option',
    registerOptionEmail: 'E-mail',
    registerOptionFacebook: 'Facebook',
    registerOptionGmail: 'Gmail',
    customizePhoto: 'Customize Photo',
    landscapeImage: 'Landscape Logo',
    squareImage: 'Square Logo',
    chooseFile: 'Choose file',
    msg6: 'Acceptable formats .png .jpg only ',
    msg7: 'Max file size is 3MB',
    errorTitleFileTooLarge: 'Error',
    errorMsgFileTooLarge: 'The file is larger than 3MB. Plase resize the file and try again.',
    errorTitleFileNotImage: 'Error',
    errorMsgFileNotImage: 'The file is not in .jpg or .png format. Please try again.',
    customizeColor: 'Customize color',
    themeColor: 'Theme color',
    headerColor: 'Header color',
    footerColor: 'Footer color',
    buttonColor: 'Button color',
    preview: 'Preview',
    seemore: 'See more',
    cancel: 'Cancel',
    save: 'Save',
    done: 'Done',
    ok: 'Ok',
    confirm: 'Confirm',
    saveFailed: 'Save failed',
    msg8: 'This domain has already been used. Please use another name.',
    msg9: 'Please specify all information.',

    companyTabbar: 'Company tabbars',
    info1: 'A tab bar appears at the bottom of an app screen and lets people quickly switch among different sections of an app. Tab bars are translucent, may have a background tint, maintain the same height in all screen orientations, and are hidden when a keyboard is displayed. A tab bar may contain any number of tabs, but the number of visible tabs varies based on the device size and orientation. If some tabs can’t be displayed due to limited horizontal space, the final visible tab becomes a More tab, which reveals the additional tabs in a list on a separate screen.',
    menuList: 'Menu List',
    delete: 'Delete',
    hover1: 'Click to edit Or drag to re-order',
    addMenu: 'Add Menu',
    newMenu: 'New Menu',
    menuName: 'Menu name',
    templateType: 'Template type',
    elementList: 'Elements list',
    info2: 'A elements manages an ordered set of content, such as a banner slider, and presents it in a customizable. Because a elements doesn’t enforce a strictly linear format, it’s particularly well-suited to displaying items that vary in size.',
    hover2: 'Drag to re-order',
    addElement: 'Add Elements',
    add: 'Add',
    contentTemplate: 'Content Template',
    elementTitle: 'Elements Title',
    elementDescription: 'Elements Description',
    ContentSetting: 'Content Setting',
    orderBy: 'Order By',
    displayItemLimit: 'Display item limit',
    mobile: 'Mobile Platform',
    tablet: 'Tablet Platform',
    desktop: 'Web Platform',
    msg10: 'Are you want to delete ?',
    msg11: 'If you delete the elements you can not get to show again',
    msg12: 'Are you want to delete this menu bar ?',
    msg13: 'If you delete this menu bar. It not show on your application.',
    msg14: 'Menu setting not complete',
    msg15: 'Successfully Saved',
    msg16: 'The menu information has been saved',
    msg17: 'The elements information has been saved',
    msg18: 'Please Choose the Type',
    msg19: 'Element Title',
    msg20: 'Element Description',
    msg21: 'Please Choose order by',

  },
  defaultLayout: {
    logout: 'Logout',
    change_pwd: 'Change Password',
    sidebar: {
      home: 'Dashboard',
      stores: 'Store',
      admin: 'Administrator',
      employee: 'Employee',
      manual: 'User Manual',

      accountManagement: 'User Management',
      user: 'Learner',
      account: 'Teacher',
      instructor: 'Instructor',
      instructorRegistration: 'Instructor Registration',

      courseManagement: 'Course Management',
      myCourse: 'Course Management',
      myCourseList: 'New Course Management',
      relatedCourse: 'Related Course',
      reportCourse: 'Report Course',

      usergroup: 'User group Management',

      banner: 'Banner Management',

      categoryManagement: 'Data Management',
      skill: 'Tag',
      category: 'Category',
      level: 'Level',
      companyManagement: 'Company Management',
      companySetting: 'Company Setting',

      notificaton: "Notificaton",
      event: "Event Management",

      report: 'Report Course',
      dashboard: 'Dashboard',
      confirmTutor: 'Confirm Tutor'
    },
    add: 'Add ',
    search: 'Search',
    list: 'List',
    edit: 'Edit',
    delete: 'Delete',
    dismiss: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    ok: 'OK',
    reset: 'Reset',
    upload: 'Upload',
    dialog: {
      uploadImg: 'Upload Pictures',
      fileOver: 'File size is over 1MB',
      uploadedText: 'Uploaded',
      successful: 'Successful'
    },
    profile: "Profile",
    editProfile: "Edit profile",
    uploadPhoto: "Upload photo",
    choosePhoto: "Choose photo",
    chooseNewPhoto: "Choose new photo",
    gender: "Gender",
    firstName: "First name",
    lastName: "Last name",
    email: "Contact Email",
    username: "Username",
    organization: "Note",
    updatePass: "Change password",
    oldPass: "Old password",
    newPass: "New password",
    confirmPass: "Confirm password",
    completed: "Done",
    least8characters: "Please enter a password of at least 8 characters",
    matchedPassword: "Please enter the matched password",
    enterFirstname: "Please enter your first name",
    enterLastname: "Please enter your last name",
    enterGender: "Please choose your gender",
    enterUsername: "Please enter your username",
    enterEmail: "Please enter your email",
    male: "Male",
    female: "Female",
    unknown: "Unknown",
    editingUserSucceeded: "Editing user succeeded",
    userInformationUpdated: "The user information is successfully updated",
    copy: "Copy",
    copied: "Copied!",
  },
  lang: {
    languages: 'Display Language',
    english: 'English',
    thailand: 'Thailand'
  },

  learnerManagement: {
    learner: 'User',
    importUsers: 'Import Users',
    exportUsers: 'Export Users',
    addUser: 'ADD USER',
    sorry: 'Sorry',
    msg1: 'You are not able to use the feature because there is ',
    msg2: 'No Permission',
    msg3: ' available for this account.',
    ok: 'Ok',
    userManageBtn: 'Users Management',
    recycleBin: 'Recycle Bin',
    sort: 'Sort',
    sortBy: 'Sort by',
    filterBar: {
      search: 'Search',
      searchNameEmail: 'Search name or email',
      selectGroup: 'Select Group',
      groupFilter: 'Group filter',
      status: 'Status',
      reload: 'Reload',
      all: 'All',
      on: 'On',
      off: 'Off'
    },
    learnerList: {
      exportReport: 'Export report',
      photo: 'PHOTO',
      prefix: 'PREFIX',
      name: 'Full Name',
      email: 'Contact email',
      username: 'username',
      group: 'Group',
      groups: 'GROUPS',
      clickToEditGroup: 'CLICK TO EDIT GROUPS',
      clickToSuspend: 'Click to Suspend',
      clickToActivate: 'Click to Activate',
      status: 'Status',
      edit: 'Edit',
      searchGroups: 'Search Groups',
      selectedGroups: 'Selected Group(s)',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      confirmSuspend: 'Do you want to suspend the user?',
      suspendDetail:
        'Once user is suspended, you are able to come back and modify the permission afterward.',
      confirmActivate: 'Do you want to activate the user?',
      activateDetail: 'The user will be activated when you click Confirm.',
      addNewUser: 'ADD NEW USER',
      editUser: 'EDIT USER',
      information: 'INFORMATION',
      accessRight: 'Access Right',
      profileImage: 'Profile image',
      upload: 'Upload',
      acceptableFormats: 'Acceptable formats',
      maxFileSize: 'Max file size is 1MB',
      accountInformation: 'ACCOUNT INFORMATION',
      prefixName: 'Prefix Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      prefixNameEng: 'Prefix Name English',
      firstNameEng: 'First Name English',
      lastNameEng: 'Last Name English',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      notSpecified: 'Not specified',

      groupRules: 'Please specify user group',
      nameRules: 'Please specify all information',
      genderRules: 'Please specify gender',
      prefixRules: 'Please specify prefix',
      firstNameRules: 'Please specify first name',
      lastNameRules: 'Please specify last name',
      prefixEngRules: 'Please specify prefix english',
      firstNameEngRules: 'Please specify first name english',
      lastNameEngRules: 'Please specify last name english',
      userNameRules: 'Please specify username',
      emailRule1: 'Please specify email',
      emailRule2: 'Please enter correct email format',
      passwordRules: 'The password must be at least 8 characters',
      confirmPasswordRules: 'The password are not matched',

      successfullySave: 'Successfully Saved',
      canModifyLater: 'You are able to modify the permission afterward',
      done: 'Done',

      organization: 'Note',
      usernameSm: 'Username',
      emailSm: 'Contact Email',
      groupSm: 'Group',
      groupsSm: 'Groups',
      selectGroup: 'Select Group',
      updatePassword: 'Update Password',
      password: 'PASSWORD',
      passwordSm: 'Password',
      confirmPassword: 'Confirm Password',

      systemManagement: 'SYSTEM MANAGEMENT',
      assignAdmin: 'Assign to be admin',
      manageUsers: 'MANAGE USERS',
      accessUserData: 'Access user data',
      editUserData: 'Edit user data',
      createNewUser: 'Create new user',
      suspendUserAccount: 'Suspend user account',

      manageGroups: 'MANAGE GROUPS',
      accessAndEditGroups: 'Access & Edit groups',

      manageCourses: 'MANAGE COURSES',
      assignInstructor: 'Assign others to be instructor',
      accessCourses: 'Access courses',
      editCourses: 'Edit courses',
      createNewCourses: 'Create new courses',
      suspendCourses: 'Suspend courses',

      dataManagement: 'MANAGE DATA',
      accessEditDelete: 'Access & Manage category/tag/level',

      bannerManagement: 'MANAGE BANNER',
      accessEditDeleteBanner: 'Access & Manage banner',

      dashboardReport: 'DASHBOARD & REPORT',
      accessDashboardReport: 'Access Dashboard & Report',

      successfullyEditingGroups: 'Successfully Edited',
      groupsSaved: 'The group information has been saved',

      headerTableGroup: {
        group: "User groups",
        ID: "ID",
      },
      viewActivity: 'View Activity',
      roleType: 'Role Type'
    },
    importUsersDialog: {
      wrongTemplate: "Wrong template",
      passwordLessThan: "The password must be at least 8 characters",
      importUsers: 'Import Users',
      createMyOwnPassword: 'Create my own password',
      generatePassword: 'Generate Password',
      downloadSample: 'Download Sample',
      dragFile1: 'Drag a file and place it here OR ',
      dragFile: 'Click here',
      dragFile2: ' to choose file',
      downloadInstruction: 'Downloading the Sample',
      downloadInstructionDetail:
        'The sample files are different between the password generating methods you select. When you choose Create my own password, the must specify the Password in the file before uploading.',
      importedFileData: 'Imported File Data',
      group: 'Group',
      chooseGroup: 'Choose Group',
      cancel: 'Cancel',
      confirmImporting: 'Confirm Importing',
      confirmEditing: 'Confirm Editing',
      pleaseWait: 'Please wait...',
      validToImport: 'Valid to Import',
      alreadyExisted: 'Already Existed',

      username: 'Username',
      prefix: 'Prefix',
      firstName: 'First Name',
      lastName: 'Last Name',
      gender: 'Gender',
      email: 'Contact Email',
      password: 'Password',
      note: 'Note',

      successfullyAdded: 'Successfully Added',
      addingIsDone: 'The users have been successfully added',
      done: 'Done',

      failedToAdd: 'Failed to Add',
      errorOccured:
        'There is a problem while adding data. Please try again later.',
      ok: 'OK',

      successfullyEdited: 'Successfully Edited',
      editingIsDone: 'The users have been successfully edited',

      failedToModify: 'Failed to Modify',
      errorEditOccured:
        'There is a problem while editing data. Please try again later.',

      failedToSave: 'Failed to Save',
      errorDuplicate:
        'The Email or Username is already chosen. Please choose other Email or Username.',

      failedToUpload: 'Failed to upload this file.',
      duplicatedEmail: 'Duplicated Email',
      or: ' or ',
      failedHeader: 'Can not use field header (can use a-z, A-Z)',
      errorDuplicatedEmail:
        'You are not able to upload this file. Please check the data.',
      close: 'Close'
    }
  },

  instructorManagement: {
    instructor: 'Instructor',
    sorry: 'Sorry',
    msg1: 'You are not able to use the feature because there is ',
    msg2: 'No Permission',
    msg3: ' available for this account.',
    ok: 'Ok',
    filterBar: {
      search: 'Search',
      cancelSearch: 'Cancel search',
      searchNameEmail: 'Search name or email',
      status: 'STATUS',
      reload: 'RELOAD',
      all: 'All',
      on: 'on',
      off: 'off',
      result: 'Click to select from the search results'
    },
    instructorList: {
      photo: 'PHOTO',
      prefix: 'PREFIX',
      name: 'NAME',
      email: 'EMAIL',
      username: 'USERNAME',
      group: 'GROUP',

      groups: 'GROUPS',
      clickToEditGroup: 'CLICK TO EDIT GROUPS',
      clickToSuspend: 'Click to Suspend',
      clickToActivate: 'Click to Activate',

      status: 'STATUS',
      searchGroups: 'Search Groups',
      selectedGroups: 'Selected Group(s)',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      confirmSuspend: 'Do you want to suspend the user?',
      suspendDetail:
        'Once user is suspended, you are able to come back and modify the permission afterward.',
      confirmActivate: 'Do you want to activate the user?',
      activateDetail: 'The user will be activated when you click Confirm.',

      successfullySave: 'Successfully Saved',
      canModifyLater: 'You are able to modify the permission afterward',
      done: 'Done',

      successfullyEditingGroups: 'Successfully Edited',
      groupsSaved: 'The group information has been saved',

      edit: 'Edit',
      editUser: 'EDIT USER',
      information: 'INFORMATION',
      accessRight: 'Access Right',
      profileImage: 'Profile image',
      upload: 'Upload',
      acceptableFormats: 'Acceptable formats',
      maxFileSize: 'Max file size is 1MB',
      accountInformation: 'ACCOUNT INFORMATION',
      prefixName: 'Prefix Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      notSpecified: 'Not specified',

      groupRules: 'Please specify user group',
      nameRules: 'Please specify all information',
      genderRules: 'Please specify gender',
      prefixRules: 'Please specify prefix',
      firstNameRules: 'Please specify first name',
      lastNameRules: 'Please specify last name',
      userNameRules: 'Please specify username',
      emailRule1: 'Please specify email',
      emailRule2: 'Please enter correct email format',
      passwordRules: 'The password must be at least 8 characters',
      confirmPasswordRules: 'The password are not matched',
      descriptionRules: 'Please enter the description',

      organization: 'Note',
      usernameSm: 'Username',
      emailSm: 'Contact Email',
      groupSm: 'Group',
      groupsSm: 'Groups',
      selectGroup: 'Select Group',
      updatePassword: 'Update Password',
      password: 'PASSWORD',
      passwordSm: 'Password',
      confirmPassword: 'Confirm Password',

      systemManagement: 'SYSTEM MANAGEMENT',
      assignAdmin: 'Assign to be admin',
      manageUsers: 'MANAGE USERS',
      accessUserData: 'Access user data',
      editUserData: 'Edit user data',
      createNewUser: 'Create new user',
      suspendUserAccount: 'Suspend user account',

      manageGroups: 'MANAGE GROUPS',
      accessAndEditGroups: 'Access & Edit groups',

      manageCourses: 'MANAGE COURSES',
      assignInstructor: 'Assign others to be instructor',
      accessCourses: 'Access courses',
      editCourses: 'Edit courses',
      createNewCourses: 'Create new courses',
      suspendCourses: 'Suspend courses',

      manageCategory: 'MANAGE DATA',
      accessEditDelete: 'Access & Manage category/tag/level',

      dashboardReport: 'DASHBOARD & REPORT',
      accessDashboardReport: 'Access Dashboard & Report',

      description: 'DESCRIPTION',
      desc: 'Write the description here...'
    },

    importUsersDialog: {
      successfullyAdded: 'Successfully Confirmed',
      addingIsDone: 'The users have been successfully added',
      done: 'Done',

      failedToAdd: 'Failed to Confirm',
      errorOccured:
        'There is a problem while saving data. Please try again later.',
      ok: 'OK',

      successfullyEdited: 'Successfully Edited',
      editingIsDone: 'The users have been successfully edited',

      failedToModify: 'Failed to Modify',
      errorEditOccured:
        'There is a problem while editing data. Please try again later.'
    }
  },

  // CoursecourseManagement
  courseManagement: {
    // title: '',
    myCourse: 'Course Management',
    newCourse: 'New Course',
    recycleBin: 'Recycle Bin',
    courseName: 'Course name',
    teacherName: 'Tutor name',
    creatorName: 'Creator name',
    search: 'Search',
    searchBy: 'Search by',
    sort: 'Sort by',
    courseCannotPublished: 'The course cannot be published due to',
    filterBar: {
      filter: 'Filter',
      search: 'Search',
      refresh: 'Reload',
      bin: 'Recycle bin',
      addCourse: 'Add course',
      lowToHighTime: 'past-recent published date',
      highToLowTime: 'recent-past published date',
      lowToHighRating: 'Low-high rating',
      highToLowRating: 'High-low rating',
      categories: 'Categories',
      skills: 'Tags',
      tags: 'Tags',
      status: 'Status',
      all: 'All',
      on: 'On',
      off: 'Off',
      selectedSkills: 'selected tag(s)',
      selectedTags: 'selected tag(s)',
      publish: 'Published',
      disable: 'Unpublished',
      plsChooseSkill: 'Please choose tags.',
      plsChooseTag: 'Please choose tags.',
      plsChooseCategories: 'Please choose categories.',
      addLive: 'Add Live',
      addBundle: 'Add Bundle',
      selectGroup: 'Select Group',
      groupFilter: 'Group filter',
    },
    lectureStep: {
      instructionStudyingDetail:
        'Studying detail',
      instructionStudyingIndependent:
        '"Independent study" means the learners will be able to study any lecture at anytime.',
      instructionStudyingSequently:
        '"Sequently study" means the learners will have to study by following the exact order of the course content',
      sectionOrLecture: 'Section/Lecture',
      lecture: 'Lectures',
      questions: 'Questions',
      noQuestion: 'To publish this exam, need at least 1 question.',
      dragToMoveSequence: 'Drag to re-order',
      clickToHideOrShow: 'Click to show or hide',
      addSection: 'Add section',
      sectionName: 'Section name',
      addTutor: 'Instructor',
      editOrAddSection: 'Edit/add section',
      edit: 'Edit',
      EnableSuspend: 'Enable/suspend',
      alertSetTimeExam:
        'If you want to specify the period of "Enable", please click the edit button.',
      alertEnable: 'Do you want to "Enable"?',
      alertSuspend: 'Do you want to "Suspend"?',
      tooltripClose: 'Close',
      alertDeleteLesson: 'Are you sure you want to delete this item?',
      alertDeleteLessonCantBringData:
        'Once this lecture has been deleted, it will not be able to recover the data.',
      alertSuccessfullyDeleteLesson: 'successfully deleted the lecture',
      alertLessonDeletedFromSystem:
        'The lecture has been deleted from the system.',
      alertNotSavedChange: 'You have not saved changes.',
      alertNotSavedCreationOrEditing:
        'You have not saved your created / edited lecture. Do you want to save?',
      alertLeavePageTitle: 'Leave Page?',
      alertLeavePageSubTitle:
        "You didn't save your lecture yet. Are you sure you want to leave without save?",
      removeSection: 'remove section',
      publish: 'Published',
      disable: 'Unpublished',
      delete: 'Delete',
      deleteSelected: "Delete selected",
      cancel: 'Cancel',
      confirm: 'Confirm',
      plsEnterSectionName: 'Please enter the section name',
      save: 'Save',
      ok: 'Ok',
      done: 'Done',
      back: 'Back',
      exit: 'Exit',
      next: 'Next',

      //insertLecture
      video: 'Video',
      document: 'Document',
      photo: 'Photo',
      book: 'book',
      website: 'Website',
      otherFiles: 'Other files',
      article: 'Article',
      examination: 'Examination',
      addLecture: 'Add lecture',
      youtube: 'Youtube',

      //insertVideo
      insertVideo: {
        addEditVideo: 'Add/Edit Video',
        close: 'Close',
        videoName: 'Video Name',
        pleaseFillName: 'Please fill in video name.',
        videoattachment: 'Video Attachment',
        mp4: 'MP4',
        details: 'Details',
        pleaseFillDetails: 'Please fill in video details.',
        chooseFile: 'Please choose a video file.',
        errorUploadAgain: 'Error, please upload again.',
        notSaved: 'You have not saved the changes',
        doYouWantToSave:
          'Adding/Editing has not been saved yet. Would you like to save?',
        maxFileSize5GB: 'The maximum file size should be smaller than 5 GB',
        maxFileSize1GB: 'The maximum file size should be smaller than 1 GB',
        cancel: 'Cancel',
        save: 'Save'
      },

      insertDocument: {
        addEditDoc: 'Add/Edit Document',
        close: 'Close',
        docName: 'Document Name',
        pleaseFillName: 'Please fill in document name',
        detail: 'Detail',
        pleaseFillDetail: 'Please fill in document detail',
        chooseFile: 'Please choose a document file',
        docFile: 'Document File',
        docFileInstruction: 'PDF file only',
        files: 'File(s)',
        sample: 'Sample',
        perMissionDownload: 'Allows users to download files',
        noDownload: 'Not allow',
        canDownload: 'Allow'
      },

      insertPhoto: {
        addEditPhoto: 'Add/Edit Photo',
        close: 'Close',
        photoName: 'Photo Name',
        pleaseFillName: 'Please fill in photo name',
        detail: 'Detail',
        pleaseFillDetail: 'Please fill in photo detail',
        chooseFile: 'Please choose a photo file',
        photoFile: 'Photo File',
        photoFileInstruction: 'JPG or PNG file only',
        photoFilePlH: 'You can upload up to 20 photos',
        files: 'File(s)',
        sample: 'Sample',
        undo: 'Undo',
        chooseBtn: "Choose File"
      },

      insertEbook: {
        addEditEbook: 'Add/Edit E-Book',
        close: 'Close',
        ebookName: 'E-Book Name',
        pleaseFillName: 'Please fill in E-Book name',
        detail: 'Detail',
        pleaseFillDetail: 'Please fill in E-Book detail',
        chooseFile: 'Please choose an E-Book file',
        ebookFile: 'E-Book File',
        ebookFileInstruction: 'PDF file only',
        files: 'File(s)',
        sample: 'Sample (E-Book)',
        undo: 'Undo',
        perMissionDownload: 'Allows users to download files',
        noDownload: 'Not allow',
        canDownload: 'Allow'
      },

      insertURL: {
        addEditURL: 'Add/Edit Website',
        close: 'Close',
        urlName: 'URL Name',
        pleaseFillName: 'Please fill in URL name',
        detail: 'Detail',
        pleaseFillDetail: 'Please fill in URL detail',
        url: 'Website (URL)',
        urlPlH: 'Please fill in URL',
        sample: 'URL Sample'
      },

      insertOther: {
        addEditOther: 'Add/Edit Other Files',
        close: 'Close',
        otherName: 'File Name',
        pleaseFillName: 'Please fill in file name',
        detail: 'Detail',
        pleaseFillDetail: 'Please fill in file detail',
        chooseFile: 'Please choose file',
        otherFile: 'File',
        files: 'File(s)',
        sample: 'File Sample',
        undo: 'Undo',
        testDownload: 'Test Download File',
        remark: 'Remark',
        msg1:
          "Once the files are uploaded, they can be downloaded to learners' devices such as ",
        msg2: 'PowerPoint',
        msg3: 'Word',
        msg4:
          " files. The files can be previewed differently depends on the learners' devices.",
        timeLeft: 'Time Remaining ',
        day: ' day(s) ',
        hour: ' hour(s) ',
        minute: ' min(s) ',
        second: ' sec(s) '
      },

      insertArticle: {
        addEditArticle: 'Add/Edit Article',
        close: 'Close',
        articleName: 'Article Name',
        pleaseFillName: 'Please fill in article name',
        detail: 'Detail',
        pleaseFillDetail: 'Please fill in article detail',
        article: 'Article',
        articlePlH: 'Please fill in article'
      },

      insertExam: {
        addEditExam: "Add/Edit Examination",
        viewExam: "View Examination",
        close: "Close",
        edit: "Edit",
        examDetail: "Examination detail",
        examQuestion: "Question",
        examName: "Examination Name",
        pleaseFillName: "Please fill in examination name",
        detail: "Examination detail",
        pleaseFillDetail: "Please fill in examination detail",
        exam: "Examination",
        examPlH: "Please fill in examination",
        question: "Question",
        instruction: "Description/Instruction of the Examination",
        timerOption: "Timer",
        noTimer: "No Timer",
        useTimer: "Use Timer",
        minute: "mins",
        second: "secs",
        times: "times",
        typeExam: "Type of Exam",
        remarkTypeExam: "Once the exam format is selected, it is not possible to change the exam format.",
        typeExamGeneral: "General",
        typeExamCustomizable: "Customizable",
        numExamTries: "Number of Exam Tries",
        sigleTime: "Single Time",
        multiTimes: "Multiple Times",
        unlimited: "Unlimited",
        questionSolving: "Show Answer",
        afterExam: "After Exam",
        oneByOne: "One by one",
        noAnswer: "No Answer",
        randomQuestions: "Random Questions",
        randomChoices: "Random Choices",
        setPercent: "Set the percentage for passing the criteria",
        no: "No",
        yes: "Yes",
        percentText: "Percent",
        random: "Yes",
        noRandom: "No",
        random2: "Yes",
        noRandom2: "No",
        conditionRandom: "Exam random conditions",
        conditionRandomFirst: "Random only for the first time",
        conditionRandomAlways: "Random every time",
        GroupAssignmentOfQuestions: "Group assignment of questions",
        noGroupAssignmentOfQuestions: "Not Define question groups",
        yesGroupAssignmentOfQuestions: "Define question groups",
        groupListQuestion: "Question group list",
        publishedTimeDate: "Published Schedule (Optional)",
        noPublishedTimeDate: "Not specified",
        setPublishedTimeDate: "Specify Schedule",
        start: "Start",
        end: "End",
        scheduleInstruction: "End date must be after start date",
        cancel: "Cancel",
        save: "Save",
        chooseRandom: "Random ",
        ofQuestion: " Question",
        ofQuestionTotal: "Of ",
        perQuestion: "",
        pointPerQuestion: " Marks/question",
        total: "Total ",
        totalScore: " Marks",
        scorePerOne: " Marks per 1 question",
        nameGroup: "Group name question",
        numberOfQuestion: "Number of question",
        addGroupQuestion: "Typing for add question group",
        addQuestionGroup: "Add question group",
        totalScoreOfExam: "Total marks",
        questionGroupFilter: 'Question group filter',
        type: 'Type',
        groupQuestion: 'Question group',
        faceDetection: "Face detection",
        faceOptionNo: "No",
        faceOptionYes: "Yes",
        faceDetectionRandom: "Random face detection",
        faceRandomOptionNo: "No",
        faceRandomOptionYes: "Yes",
        faceChooseNumberOfQuestion: "Select number of question",
        faceMsg1: "Select number of question",
        faceMsg2: "Please add a question first.",

        instructionQuestion: "Instruction",
        msg1: "How to add questions",
        msg2: "You can add ",
        msg3: "1 new question at a time",
        msg4: "by clicking the",
        msg5: "New question",
        msg6: "button.",
        msg7: "How to import question",
        msg8: "You can add questions of",
        msg9: "Single Choice",
        msg10: "or",
        msg11: "Multiple Choice",
        msg12: "with multiple questions at a time by clicking",
        msg13: "Import Exam",
        msg14: " button.",
        msg15: "Remark",
        msg16: "by importing the Excel file to add questions, you are not able to add other kinds of media such as photos, voices, and videos right away.",
        msg17: "In case you would like to add them afterward, please click ",
        msg18: "Edit Question",
        msg19: "button after the questions are already imported.",
        mssg20: "When choosing a Customizable",
        mssg21: "Some of the features of Exam Creation will not be available, such as a match exam, articles and games.",
        mssg22: "Create exam",

        importExam: "Import Exam",
        singleChoice: "Single Choice",
        multipleChoices: "Mulitple Choices",
        matching: "Matching",
        fillBlank: "Fill the Blank",
        article: "Article",
        game: "Game",


        newQuestion: "New Question",
        selectAll: "Select All",
        delete: "Delete",
        selectToDelete: "Select to delete",
        noQuestion: "No data yet. Please click \"+ New Question\" button to add question",
        modifyExam: "Exam Ordering",

        saveDone: "The exam is successfully saved",
        done: "Done",

        saveFailed: "Failed to save the exam",
        saveFailedDetail: "Please check again",
        ok: "Ok",

        failedMsg1: "Please check the accuracy of the timer.",
        failedMsg2: "Please check the accuracy of the repeat.",

        deleteQuestionConfirm: "Do you want to delete the question?",
        deleteQuestionConfirmDetail: "The question(s) will be permanently deleted once you click the Confirm button.",
        confirm: "Confirm",
        doingDelete: "deleting",

        deleteDone: "Successfully deleted",
        deleteDoneDetail: "The Question is successfully deleted.",

        deleteMultiConfirm: "Do you want to delete the selected question(s)?",

        importSingleChoice: "Import Single Choice Question(s)",

        msg20: "Instruction",
        msg21: "Single Choice Question",
        msg22: "The examiner can choose only",
        msg23: "1 choice.",
        mssg24: "At the ID column",
        mssg25: "Can put the group's ID in the box question_group_id in the Excel file.",

        downloadSample: "Download Sample",
        sampleImportData: "Import Question(s)",
        confirmToImport: "Confirm Importing",
        uploading: "Uploading",



        importMultiChoice: "Import Multiple Choice Question(s)",
        msg24: "Instruction",
        msg25: "Multiple Choice Questions",
        msg26: "The examiner can choose",
        msg27: "more than 1 choice.",

        num: "No",
        score: "Score",
        questionQ: "Question",
        correctAns: "Answer",
        ansDescription: "Decription",
        choice: "choice",

        failedUpload: "Failed to upload Question(s)",
        failedUploadDetail: "With Single Choice Questions, only 1 choice can be chosen.",
        drag: "Drag to change order",
        confirmDeleteQuestionGroup: "Do you want to delete the question group?",
        confirmDeleteQuestionGroupDetail: "The question group will be permanently deleted once you click the Confirm button.",
        deleteQuestionGroupDone: "Successfully deleted",
        deleteQuestionGroupDoneDetail: "The Question group is successfully deleted.",
        savingFailed: "Saving failed",
        importFailed: 'Import failed',
        importAgain: 'Please import this exam again. Starting from item',
        // importError: 'You are not able to import this file. Please check the data.',
        importError: "The content of the exam was found to be <b><u>incomplete</u></b>.<br/> Question number ",
        importErrorAndCheckAgain: 'Please check the data and import again.',
        closeImportError: 'Close',
        questionGroupDuplicate: "Duplicated question group name. Please enter another question group name to add question group",
        
        saveFailMsg: "Something went wrong, please try again.",
        uploadFile: "Upload File",
        btnBackLecture: "Back to lecture",

        tableHeadersQuestionGroup: {
          questionGroupName: "Question group name",
          randomNumber: "Random",
          totalNumber: "Total",
          score: "Score",
          totalScore: "Total Score",
          editQuestionGroup: "Actions",
          titleDialogAdd: "Add question group",
          titleDialogEdit: "Edit question group"
        },

        tableHeaderLevel: {
          questionGroupName: "Question group name",
          countRandom: "Random (Number of question)",
          score: "Marks / questions",
          ID: "ID",
        },

        tableHeaderNormal: {
          no: "No",
          score: "Marks",
          question: "Question",
          correctAns: "Correct answer",
          ansDescription: "Answer description",
          choice1: "Choice 1",
          choice2: "Choice 2",
          choice3: "Choice 3",
          choice4: "Choice 4",
          choice5: "Choice 5",
          choice6: "Choice 6",
          choice7: "Choice 7",
          choice8: "Choice 8",
          choice9: "Choice 9",
          choice10: "Choice 10",
        },

        tableHeaderRandom: {
          no: "No",
          questionGroup: "Question group",
          score: "Marks",
          question: "question",
          correctAns: "Correct answer",
          ansDescription: "Answer description",
          choice1: "Choice 1",
          choice2: "Choice 2",
          choice3: "Choice 3",
          choice4: "Choice 4",
          choice5: "Choice 5",
          choice6: "Choice 6",
          choice7: "Choice 7",
          choice8: "Choice 8",
          choice9: "Choice 9",
          choice10: "Choice 10",
        },

        tableHeadersQuestionList: {
          typeOfQuestion: "Question type",
          questionGroup: "Question group",
          score: "Score",
          actions: "Actions",
          questionList: "Question list",
          totalQuestion: "Total question"
        },

        insertSingle: {
          addSingle: "Add/Edit Question (Single Choice)",
          chooseQuestionGroup: "Select question group",
          question: "Question",
          addVoiceOpt: "Add Voice (optional)",
          addVoice: "Add Voice",
          addVdoOpt: "Add Video (optional)",
          addVdo: "Add Video",
          score: "Score",
          randomType: "Choices Random Type",
          noRandom: "Not random",
          random: "Random",
          msg1: "Remark",
          msg2: "to choose the correct answer, please select the radio button of the choice.",
          answer: "Answer",
          choices: "Choices",
          choice: "Choice",
          addChoice: "Add Choice",
          answerDescription: "Answer Description",
          confirmDeleteChoice: "Do you want to delete the choice?",
          confirmDeleteChoiceDetail: "Once you click Confirm, the choice will be permanently deleted.",
          saveDone: "Successfully saved",
          saveDoneDetail: "You can come back and modify later.",
          questionRules: "Please enter question",
          answerDescriptionRules: "Please enter answer description",
          scoreRules: "Please enter score",
          choiceMsg1: "Type your choice in the text box. And press the Add Choice button.",
          choiceMsg2: "You can add a description of the solution by typing a description of the solution in the text box.",
          choiceList: "Choices list",
          choiceMsg3: "There is no choice list yet. Please add an choice below.",
        },

        insertMultiple: {
          addMultiple: "Add/Edit Question (Multiple Choice)",
          chooseQuestionGroup: "Select question group",
          question: "Question",
          addVoiceOpt: "Add Voice (optional)",
          addVoice: "Add Voice",
          addVdoOpt: "Add Video (optional)",
          addVdo: "Add Video",
          score: "Score",
          randomType: "Choices Random Type",
          noRandom: "Not random",
          random: "Random",
          msg1: "Remark",
          msg2: "to choose the correct answer, please select the radio button of the choice.",
          answer: "Answer",
          choices: "Choices",
          choice: "Choice",
          addChoice: "Add Choice",
          answerDescription: "Answer Description",
          confirmDeleteChoice: "Do you want to delete the choice?",
          confirmDeleteChoiceDetail: "Once you click Confirm, the choice will be permanently deleted.",
          saveDone: "Successfully saved",
          saveDoneDetail: "You can come back and modify later.",
          questionRules: "Please enter question",
          answerDescriptionRules: "Please enter answer description",
          scoreRules1: "Please enter score",
          scoreRules2: "The score must be greater than 0",
          choiceMsg1: "Type your choice in the text box. And press the Add Choice button.",
          choiceMsg2: "You can add a description of the solution by typing a description of the solution in the text box.",
          choiceList: "Choices list",
          choiceMsg3: "There is no choice list yet. Please add an choice below.",
        },

        insertFillTheBlank: {
          addFillTheBlank: "Add/Edit Question (Fill the blank)",
          chooseQuestionGroup: "Select question group",
          question: "Question",
          addVoiceOpt: "Add Voice (optional)",
          addVoice: "Add Voice",
          addVdoOpt: "Add Video (optional)",
          addVdo: "Add Video",
          percent: "Expected accuracy percentage",
          score: "Marks",
          randomType: "Choices Random Type",
          noRandom: "Not random",
          random: "Random",
          msg1: "Remark",
          msg2: "Scoring",
          msg3: "to determine the full score of this question",
          msg4: "Determining the expected accuracy percentage",
          msg5: "to check the sentences of the given set of answers And the answers of the test takers when the sentence-form detection system matches the specified percentage of accuracy. Test takers will score points as indicated above.",
          answer: "Answer",
          packChoices: "Answer set",
          fillChoice: "Answer",
          choice: "Answers used for validation",
          choices: "Answer ",
          addChoice: "Add Answer",
          answerDescription: "Answer Description",
          confirmDeleteChoice: "Do you want to delete the choice?",
          confirmDeleteChoiceDetail: "Once you click Confirm, the choice will be permanently deleted.",
          saveDone: "Successfully saved",
          saveDoneDetail: "You can come back and modify later.",
          questionRules: "Please enter question",
          answerDescriptionRules: "Please enter answer description",
          scoreRules1: "Please enter score",
          scoreRules2: "The score must be greater than 0",
          percentRules1: "Please enter percentage",
          percentRules2: "The accuracy percentage is between 0-100.",
          answerRules: "Please enter a valid answer for validation.",
          choiceMsg1: "Type your answer in the text box. And press the Add Answer button.",
          choiceMsg2: "You can add a description of the solution by typing a description of the solution in the text box.",
          choiceList: "Choices list",
          choiceMsg3: "There is no choice list yet. Please add an choice below.",
        },

        insertMatching: {
          addMatching: "Add/Edit Question (Matching)",
          question: "Question",
          addVoiceOpt: "Add Voice (optional)",
          addVoice: "Add Voice",
          addVdoOpt: "Add Video (optional)",
          addVdo: "Add Video",
          randomType: "Choices Random Type",
          noRandom: "Not random",
          random: "random",
          score: "Marks",

          ansOption: "Answer options list",
          msg1: "Step 1",
          msg2: "Enter answer",
          msg3: "A side",
          msg4: "and",
          msg5: "B side",
          msg6: "Step 2",
          msg7: "press button",
          msg8: "matching",
          msg9: "And then tap on the option you want to matching in",
          msg10: "B side",
          msg11: "When finished, press the button",
          msg12: "done",
          msg13: "(To edit the match, press the button",
          msg14: "matching",
          msg15: "again)",
          msg16: "Step 3",
          msg17: "Enter score on",
          msg18: "A side",
          info1: "Typing in text box to add choice on A side.",
          info2: "Typing in text box to add choice on B side.",
          addChoiceASide: "Add choice A side",
          addChoiceBSide: "Add choice B side",
          choiceASide: "A Choice ",
          choiceBSide: "B Choice ",
          scoreChoice: " marks",
          matchingWith: "matching",
          choiceMatching: "B Choice ",
          info3: "Press choice on B side to matching.",
          match: "Match",
          done: "Done",
          info4: "Remark to option pairing method Press the 'Match Option' button, then tap on the option you want to pair in the Options side.When done, press the 'Done' button.",

          answerDescription: "Answer Description",
          confirmDeleteChoice: "Do you want to delete the choice?",
          confirmDeleteChoiceDetail: "Once you click Confirm, the choice will be permanently deleted.",
          saveDone: "Successfully saved",
          saveDoneDetail: "You can come back and modify later.",
          questionRules: "Please enter question",
          answerDescriptionRules: "Please enter answer description",
          scoreRules1: "Please enter score",
          scoreRules2: "The score must be greater than 0",
        },

        insertArticle: {
          addMatching: "Add/Edit Question (Article)",
          articleName: "Article name",
          question: "Article",
          saveDone: "Successfully saved",
          saveDoneDetail: "You can come back and modify later.",
          articleRules: "Please enter article",
          scoreRules1: "Please enter score",
        },

        insertGame: {
          addGame: "Add/Edit Question (Game)",
          question: "Question",
          addVoiceOpt: "Add Voice (optional)",
          addVoice: "Add Voice",
          addVdoOpt: "Add Video (optional)",
          addVdo: "Add Video",
          score: "Marks",
          totalScore: "Total Marks",
          typeGame: "Game Type",
          MemoryGame: "Memory Game",
          CrosswordPuzzle: "Crossword Puzzle",
          WordSearchPuzzle: "Word Search Puzzle",

          randomType: "Game Random Type",
          noRandom: "Not random",
          random: "random",
          countRandom: "Random Number",
          randomRules: "Please enter Random",
          packGame: "Set ",
          msg1: "Take the first picture",
          addPhoto: "Add a matching picture",

          sizeTables: "Size Of Table Answer",
          sizeTable: "Size Of Table",
          tableAnswer: "Table Answer",
          listWord: "Word List",
          msg2: "Please enter words to the table.",
          msg3: "Enter words to the field",
          scoreRules: "Please enter score",
          questionRules: "Please enter question",
          msg4: "The game can be randomized since there are 3 or more matching pictures.",
          msgCrossword: "คำอธิบายวิธีการสร้างเกมอักษรไขว้",
          msgWordsearch: "คำอธิบายวิธีการสร้างเกมค้นหาคำศัพท์",
          msgCreate1: "กำหนดขนาดตารางกำหนดคำตอบ ที่มีขนาด กว้าง x ยาว เท่ากัน",
          msgCreate2: "กำหนดคำศัพท์ในตารางคำตอบ โดยเริ่มจาก คลิกที่ช่องในตารางแล้วลากเมาส์ไปตามจำนวนอักษรของคำศัพท์ที่กำหนดไว้ ระบบจะปรากฏป๊อปอัพให้ใส่อักษรในแต่ละช่องเพื่อประกอบเป็นคำศัพท์",
          msgCreate3: 'สามารถแก้ไขคะแนนของแต่ละคำศัพท์ได้ โดยคะแนนจะปรากฏที่ด้านล่างของตารางคำตอบ และสามารถดูคะแนนทั้งหมดของคำศัพท์ทุกคำได้ที่ช่อง "คะแนนรวม"',
          msgCreate4: 'สามารถลบคำศัพท์ที่ไม่ต้องการ โดยการกดปุ่ม "ลบ" ที่ปรากฏอยู่ด้านล่างของตารางคำตอบ',
        },

      },

      //insertYoutube
      insertYoutube: {
        addEditYoutube: 'Add/Edit Youtube',
        close: 'Close',
        videoName: 'Video Name',
        pleaseFillName: 'Please fill in video name.',
        details: 'Details',
        pleaseFillDetails: 'Please fill in video details.',
        seeSample: 'See Sample',
        url: 'Youtube URL',
        fillURL: 'Please paste Youtube link (URL) here.',
        sample: 'Sample',
        notSaved: 'You have not saved the changes',
        doYouWantToSave:
          'Adding/Editing has not been saved yet. To save, press CONTINUE and then SAVE Or cancel by clicking CANCEL.',
        continue: 'Continue',
        ok: 'Ok',
        isId: 'Did you provide the Youtube ID?',
        errorFillAgain:
          'If you sample is not available, please fill in the youtube URL/ID again.',
        cancel: 'Cancel',
        save: 'Save'
      }
    },
    certificateStep: {
      certificateOption: "Offer certificate option",
      noCertificate: 'No',
      yesCertificate: 'Yes',
      setPercent: 'Set percent',
      setPercentDetail1: 'The student must complete course more than ',
      setPercentDetail2: ' inorder to get the certificate.',
      certificateStyle: 'Certificate Style',
      background: 'Background',
      studentName: 'Learner',
      courseName: 'Course name',
      issuedDate: 'Issued date',
      expDate: 'Expiration date',
      dateFormat: 'dd mm yyyy',
      issuedOn: 'Online Training on ',
      expOn: 'Exp. On ',
      dateDeliver: 'Set issued date',
      dateOptionAuto: 'Automatic',
      dateOptionFixed: 'Fixed date',
      dateMsg1: 'Learners will receive when complete the percentage set.',
      dateExp: 'Set expiration date',
      dateExpOptionFlexible: 'Flexible date',
      dateExpOptionFixed: 'Fixed date',
      dateMsg2: 'Expires after receiving',
      dateMsg3: 'Month',
      pleaseSelectOrUploadBackground: 'Please select or upload background',
      chooseImage: 'Upload image',
      acceptBackgroundFormat: 'Acceptable formats：.png .jpg only',
      maxFileSize: 'Max file size is ',
      backgroundTemplate: 'Background template',
      studentNameNo: 'Hide learner',
      studentNameYes: 'Show learner',
      courseNameNo: 'Hide course name',
      courseNameYes: 'Show course name',
      dateNo: 'Hide date',
      dateYes: 'Show date',
      textSize: 'Text size',
      textColor: 'Text color',
      textPosition: 'Text position',
      downUp: 'Down-up',
      leftRight: 'Left-right',
      dialogThereisAnError: 'There is an error',
      dialogTheFileIsTooBig: 'The file size is too big. Please select a file size less than',
      dialogTheFileNotJpgOrPng: 'The system does not support this file type. Please select only .jpg or .png file.',
      dialogBtnOK: 'OK',
      dialogUpdateFail: 'Fail to save the data. Please try again later.',
      dialogUpdateSuccessTitle: 'Success to update the data',
      dialogUpdateSuccessText: 'The data has been saved completely.',
      dialogCancel: 'Cancel',
      dialogConfirm: 'Confirm',
      btnSave: 'Save',
    },
    whoCanSeeStep: {
      howToShow: "Accessibility option",
      everyOne: "Every one",
      onlySpecificGroups: "Only specific groups",
      noteTitle: "Note",
      note1: "1. Even the students cannot see the course to register. The admins can assign the course to the students by using Learner Management tab.",
      note2: "2. The students who have registed this course still be able to study even if their names have been removed from the list.",
      groupList: "Group list",
      selectedGroupList: "Selected group list",
      publish: "Published",
      unPublish: "Unpublished",
      groupListFailTitle: "Fail to update user groups.",
      groupListFailText: "There is an error to save user groups. Please try again.",
      groupListSuccessTitle: "Success to update user groups",
      groupListSuccessText: "User groups have been saved",
      savingSetting: "Saving setting ...",
      savingSettingSuccess: "The setting has been saved.",
      savingSettingFail: "Fail to save the setting.",
      confirmWhoCanSeeEveyoneTitle: "Eyeryone can see the course.",
      confirmWhoCanSeeEveyoneText: "Changing this setting will remove all groups from the course. Please confirm to do the action.",
      confirmWhoCanSeeEveyoneCancelBtn: "Cancel",
      confirmWhoCanSeeEveyoneConfirmBtn: "Confirm",
      filterText: "Filter",
      filterResult: "Filter result",
    },
    courseList: {
      courseImage: 'Course cover',
      category: 'Categories',
      prices: 'Prices',
      status: 'Status',
      viewReport: 'View Report',
      addStudent: 'Add learner',
      edit: 'Edit',
      pending: 'Pending',
      manage: 'Manage',
      manageLearner: 'Manage',
      clickToSuspend: 'Click to Suspend',
      clickToActivate: 'Click to Activate',
      cancel: 'Cancel',
      save: 'Save',
      more: 'More',
      editCourse: 'Edit course information',
      action: 'Action',
      free: 'Free',
      baht: 'Baht',
      report: 'Report',
      confirmDeleteItem: 'Are you sure you want to delete this item?',
      confirmUnpublish:
        'Do you want to suspend the publication of this course?',
      unpublishDescript:
        'Once the course is suspended, you can come back to publish afterward.',
      confirmPublish: 'Do you want to publish this course?',
      publishDescript:
        'Once the course is publish, learner can see this course.',
      sorry: 'Sorry,',
      alertPermissionFunction:
        'you are not able to use this function because your account does not have the <strong>permission.</strong>',
      alertPermissionTeacher:
        'you are not able to access this item because your account does not have the <strong>permission</strong> to access to this item, please <strong>register</strong> to be a lecturer',
      alertRejectTeacher:
        "<strong>Registering</strong> to be a lecturer using this account is <strong class='red--text'>deny</strong> <br /><br /><strong style='text-decoration:underline'>because</strong>",
      ok: 'OK',
      alertNotAbleToAccess:
        'you are not able to access to this item yet. The <strong>registration</strong> to be a lecturer has not been <strong>approved</strong> by the admin yet.',
      chooseStudyingGroup: 'Choose studying classroom',
      studentListInCourse: 'Learner list of the course',
      filter: 'Filter',
      clearFilter: 'Clear Filter',
      progress: 'Progress',
      seeReport: 'View Report',
      accomplishment: 'Overall Accomplishment (%)',
      video: 'Video (%)',
      pdf: 'PDF (%)',
      exam: 'Examination (%)',
      studentInformation: 'Learner information',
      progressReport: 'progress report',
      student: 'Learner',
      delete: 'Delete',
      editExpDate: 'Edit Expiration date',

      // users
      studentManagement: 'Manage learners',

      successfullySave: 'Successfully Saved',
      canModifyLater: 'You are able to modify the permission afterward',
      done: 'Done',

      failedToSave: 'Not able to save because '
    },
    courseReport: {
      report: "Course Report",
      courseDetail: 'Course Detail',
      examReport: 'Exam Report',
      exam: 'Examination',
      fullMarks: 'Full marks',
      marks: 'Marks',
      question: 'Number of questions',
      questions: 'Questions',
      learner: 'Leaners',
      studentTest: 'Number of learner the exam',
      faceDetectionPass: 'Face detection pass',
      faceDetectionFail: 'Face detection fail',
      detailLearner: 'Detail of learner',
      statusFace: 'Face detection status',
      nofaceDetection: 'This test does not include face detection.',
      all: 'All',
      pass: 'Pass',
      fail: 'Fail',
      filterExam: 'Exam number filter',
      selectAll: 'Select all',
      selectNumber: 'Select number',
      notReadyNumber: 'This exam has no test history.',
      nottest: 'Not yet tested',
      notface: '-',
      faceFail: 'face scan failed',
      faceSuccess: 'face scan successes',
      clearTicketExam: 'delete exam history',
      skip: 'The user skipped the face scan',
      export: 'Export report',
      exportAll: 'Export all reports',
      headerName: 'Full Name',
      headerEmail: 'Email',
      headerNumberOfTime: 'Number of times',
      faceStatusNo: 'No face scaning',
      faceStatusError: 'Wait consideration',
      faceStatusPass: 'Pass',
      faceStatusNotPass: 'Not pass',
      moreDetail: 'Detail',
      test: 'Test',
      testTime: 'times',
      history: 'History Examination',
      unitTime: '',
      headers: {
        prefix: 'Prefix',
        fullName: 'Full Name',
        email: 'Email',
        note: 'Note',
        numberExam: 'Number of times',
        statusFace: 'Face detection status',
        action: '',
      }
    },
    detailStep: {
      instructionSkill:
        '<strong class="font-weight-bold"><label class="headExplan">"</label>Tag<label class="headExplan">"</label> instruction</strong><br /> You can create a new tag name by typing the name of the tag you want and pressing the <strong class="font-weight-bold">Enter or Spacebar</strong> key so learners can search for your course from this tag name.',
      instructionStudying:
        '<strong class="font-weight-bold"><label class="headExplan">"</label>Studying <label class="headExplan">"</label> instruction</strong><br />',
      instructionStudyingIndependent:
        '"Independent study" means the learners will be able to study any lecture at anytime.',
      instructionStudyingSequently:
        '"Sequently study" means the learners will have to study by following the exact order of the course content',
      instructionBoard:
        '<strong class="font-weight-bold">Note <label class="headExplan">"</label>discussion board<label class="headExplan">"</label></strong><br /> the learners will be able to share the discussion to one another via mobile application.',
      instructionSendDM:
        '<strong class="font-weight-bold">Note <label class="headExplan">"</label>send direct message to lecturer<label class="headExplan">"</label></strong><br />  the learners will be able to send direct message to lecturer.',
      instructionCourseCover:
        '<strong class="font-weight-bold">Note <label class="headExplan">"</label>course cover photo<label class="headExplan">"</label></strong><br />  the cover photo of the course should be 4:3 of the ratio to get the best view on the mobile application.',
      ok: 'Ok',
      errorEditing: '',
      unsuccessfulEditing: ''
    },
    faceDetection: {
      title: 'Face Detection',
      imageProfile: 'Image used to register',
      name: 'Name',
      email: 'Email',
      examDate: 'Exam Date',
      faceStatus: 'Face Detection Status',
      faceDetection: 'Face Detections',
      numberDetection: 'The time',
      minute: 'hours',
      newPhoto: 'New photo waiting consideration',
      skipPhoto: 'The user skipped the face scan',
      hardwareError: 'Hardware error',
      pass: 'Pass',
      notPass: 'Not pass',
      save: 'Save change',
      faceNoRegis: 'The face has not been registered.'
    },
    accessStep: {
      search: 'Search',
      classroom: 'Classroom',
      started: 'Started',
      notStarted: 'Not Started',
      reload: 'Reload',
      progressReport: 'progress report',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      birthdate: 'Birthdate',
      gender: 'Gender',
      course: 'Course',
      lesson: 'Lesson',
      lecture: 'Lecture',
      detail: 'Detail',

      pdf: 'PDF',
      exam: 'EXAM',
      book: 'BOOK',
      vdo: 'VDO',
      youtube: 'YOUTUBE',
      blog: 'BLOG',
      img: 'IMG',
      file: 'FILE',
      url: 'URL',

      completedLearner: 'Completed Learner',

      reportExam: 'Report Examination',
      fullScore: 'Full Score',
      numOfQuestions: 'Number of Questions',

      num: 'No',
      examDate: 'Exam Date',
      score: 'Score',
      correct: 'Correct',
      wrong: 'Wrong',
      noAnswer: 'No Answer',
      action: 'Action',

      editScore: 'Edit Score Examination',
      question: 'Question',
      examType: 'Exam type: ',
      notAnswer: 'Not Answer',

      answer: 'Answer',
      of: '',
      answerCorrect: 'Correct Answer',
      title: 'Title',
      matchTo: 'match to',
      seeAnswer: 'See answer',

      canNotPublish: 'not able to publish the course because ',

      successfullySave: 'Successfully Saved',
      canModifyLater: 'You are able to modify the permission afterward',
      done: 'Done',

      deleteStudent: 'Do you want to remove the learner from the group?',

      singleChoice: 'Single Choice',
      fillGapText: 'Fill Gap',
      match: 'Matching',
      multiChoice: 'Multiple Choice',

      courseInfoNotCompleted:
        'Invalid Data! Please complete all information of the course!',
      createSuccess: 'Successfully, creating course!',

      learner: 'Learner',

      instructionPermissionMajor:
        '<strong class="font-weight-bold"><label class="headExplan">"</label>Assigning group/faculty/major can access<label class="headExplan">"</label> instruction</strong><br /> the permission of any faculties and majors to access courses, please enter the group/faculty/field name to search.',
      WhichMajorAccess: 'Which group/faculty/major can access the course?',
      instructionPermissionOrganization:
        '<strong class="font-weight-bold"><label class="headExplan">"</label>Assigning groups to organizations<label class="headExplan">"</label> instruction</strong><br /> click the <strong class="font-weight-bold">"choose group"</strong> button to search for group/faculty/major.',
      organizationAccess: 'Organization that can access',
      remove: 'Remove',
      chooseGroup: 'Choose group',
      addOrganization: 'Add organization',
      classroomGroup: 'Classroom / group',
      back: 'Back',
      save: 'Save',
      close: 'Close',
      ChooseGroupOrFaculty: 'Choose the group/faculty/field.',
      enterToSearch: 'Enter to search',
      userGroupRequired: 'User Group is Required',
      organizationLogo: 'Organization logo',
      organizationName: 'Organization name',
      manageLearner: 'Manage learner',
      all: 'All',
      add: 'Add',

      // Room
      addClassroom: 'Add classroom/group',
      wantDelete: 'Are you sure you want to delete this item?',
      addClassroomGroup: 'Add classroom/group',
      classroomName: 'Classroom/group name',
      plsEnterGroupName: 'Please enter the group name',
      tutorNameOfGroup: 'Tutor name of the group',
      EnterTutorNameToSearch: 'Enter the tutor name to search',
      permissionEditInformation: 'Permission to edit information',
      canEditCourse: 'Can edit the course information',
      unableEditCourseInformation: 'Unable to edit the course information',
      alertSuspendClassroomGroup: 'Do you want to suspend the classroom group?',
      alertEnableClassroomGroup: 'Do you want to enable the classroom group?',
      alertAfterSuspendClassroomGroup:
        'Once you suspend the classroom group, you are able to make it enable again later.',
      alertAfterEnableClassroomGroup:
        'Once your confirm, the classroom group will be able to be accessed again.',
      savingFailed: 'Saving failed',
      alertDuplicatedGroupName:
        'Duplicated group name. Please enter another group name to add group',
      lecturerName: 'Lecturer name',
      numberStudents: 'Number of learners',
      status: 'Status',
      editClassroomGroup: 'Edit classroom group',

      manageLearners: {
        ok: "OK",
        manage: 'Manage Learner',
        importLearner: 'Import Learner',
        uploadFile: 'File Upload',
        addLearner: 'Add Learner',
        addLearnerFromCourse: 'Add Learner From Other Course',
        addLearnerFromUserGroup: 'Add Learner From Group',
        requestJoinGroup: 'Join course request',
        downloadSample: 'Download Sample',

        profile: 'Profile Photo',
        fullName: 'Full Name',
        group: 'Group',
        status: 'Status',
        action: 'Action',

        groups: 'Groups',
        groupsLg: 'GROUPS',
        remove: 'Reject',
        approve: 'Approve',
        confirmRemove: 'Do you want to remove the learner from the group?',

        successRemove: 'Successfully Removed',
        successRemoveDetail: 'The data is permanently removed',
        done: 'Done',

        importAvailable: 'Available to Import',
        existed: 'Already in Class',
        importFailed: 'Failed to Import',

        username: 'Username',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        deleting: 'Deleting',
        remark: 'Remark',
        confirm: 'Confirm',
        cancel: 'cancel',
        confirmImport: 'Confirm Importing',

        searchStudent: 'Search Learners',
        searchStudentPlH: 'Type to search',
        noData: 'No Data',
        close: 'Close',

        add: 'Add',
        alreadyInCourse: 'Added',
        notInCourse: 'Not yet in course',

        chooseRoom: 'Choose Course',
        chooseRoomPlH: 'Please choose course',
        addInstruction:
          'Once you click "Confirm Adding" only the new learners will be added',
        confirmAdding: 'Confirm Adding',

        specifyExpDate: 'Specify expire date',
        expType: 'Expiration type',
        selectExpDate: 'Select Expire Date',
        save: 'Save',

        chooseDate: 'Specify Expire Date',
        lifeTime: 'Life time',

        request: 'Request',
        certificate: 'Send certificate',
        selected: 'Selected',
        sendSelected: 'Send selected',
        send: 'Send',

        DeleteFromGroup: 'Delete from group',
        msg1: 'List of persons eligible for this course',

        statusAll: 'All',
        statusStart: 'Started',
        statusNotStart: 'Not Started',
        deleteSelected: 'Delete selected',
        btnViewReport: 'View report',
        btnViewActivity: 'View activity',
        btnEditExp: 'Edit expiration',
        btnRemove: 'Remove from course',
        selectGroup: 'Select group',
        sendingEmail: 'Sending email',
        deleteAll: 'Delete all',

        warningMsg1: 'Successfully Deleted',
        warningMsg2: 'Can edit information later',
        warningMsg3: 'Do you want to remove learner from this course?',
        warningMsg4: 'Would you like to remove the selected learners from the course?',
        warningMsg5: 'Once deleted, data cannot be returned.',
        warningMsg6: 'The learner has been deleted.',
        warningMsg7: 'The learner has been removed from the course successfully.',
        warningMsg8: 'Confirm the send of the certificate to the selected learners.',
        warningMsg9: 'Send emails to learner successfully.',
        warningMsg10: 'Failed to send email to learner.',
        warningMsg11: 'Would you like to remove learners from the selected group from the course?',
        warningMsg12: 'Failed to delete learner',
        warningMsg13: 'Something is wrong Please try again.',

        calendar: {
          headerTitle: 'Calendar activity',
          close: 'Close',
          today: 'Today',
          day: 'Day',
          week: 'Week',
          month: 'Month',
          attended: 'Attended at',
          closeToggle: 'Close',
        },

        viewReport: {
          username: 'Username',
          email: 'Email',
          phone: 'Phone',
          birthdate: 'Birthdate',
          gender: 'Gender',
          course: 'Course',
          lesson: 'Lesson',
          lecture: 'Lecture',
          btnDetail: 'Detail',

          pdf: 'PDF',
          exam: 'EXAM',
          book: 'BOOK',
          vdo: 'VDO',
          youtube: 'YOUTUBE',
          blog: 'BLOG',
          image: 'IMAGE',
          file: 'FILE',
          url: 'URL',
        },

        reportExam: {
          selectExportPattern:"Please select an export pattern.",
          all: 'All Score',
          best: 'Best Score',
          headerTitle: 'Report examination',
          fullScore: 'Full score',
          numberOfQuestion: 'Number of questions',
          numberOfQuestions: 'Number of questions',
          numberOfQuestionsInLib: 'Number of questions in the library',
          warning1: 'Do you want to delete your exam history?',
          warning2: 'If deleted, the data cannot be returned.',
          successfullySave: 'Successfully Saved',
          successMsg1: 'The students exam history has been deleted. Cannot bring any more information back',
          done: 'Done',
          editScore: 'Edit Score Examination',
          question: 'Question',
          typeExam: 'Type of exam',
          fromArticle: 'From the article',
          score: 'Score',
          noAnswer: 'Did not answer the question',
          answer: 'Answer',
          examAnswer: 'Exam answer',
          alertDeleteTicket: 'Are you sure you want to delete all exam history?',
          alertDeleteTicketCantBringData: 'Once exam history has been deleted, it will not be able to recover the data.',
          passwordContinuePlH: 'Please enter the password to continue.',
          password: 'Password',
          passwordPlH: 'Please enter the password',
          topic: 'Option A Side',
          matchihng: 'Option B Side',
          viewAnswer: 'View answer',

          headerEditScore: {
            no: 'No.',
            examDate: 'Exam date',
            start: 'Start time',
            end: 'End time',
            timer: 'Time spent',
            score: 'Score',
            correct: 'Correct',
            wrong: 'Wrong',
            noAnswer: 'No answer',
            faceDetection: 'Face detection',
          },

        },



      }
    },
    liveStep: {
      liveHeader: "Live",
      searchLiveName: 'Search Live Name',
      search: 'Search',
      liveStatusFilter: 'Live Status Filter',
      all: 'All',
      waitLive: 'Wait Live',
      live: 'Live',
      liveEnd: 'Live End',
      reload: 'Reload',
      addLive: 'Add Live',

      liveName: 'Live Name',
      startDate: 'Start Date',
      endDate: 'End Date',
      liveStatus: 'Live Status',
      action: 'Action',

      onLive: 'Live now',
      liveStarted: 'Preparing Live',
      liveEnded: 'Ended Live',

      dashboard: 'Dashboard',
      delete: 'Delete',

      addQuestion: 'Add Question',
      addPoll: 'Add Poll',

      addLiveDialog: {
        editAddLive: 'Edit/Add Live',
        close: 'Close',
        detail: 'Detail',
        room: 'Room',
        media: 'Teaching Media',
        question: 'Question',
        pictureForQuestion: "Picture for the question",
        startDate: 'Start Date',
        date: 'Date',
        cancel: 'Cancel',
        ok: 'Ok',
        hh: 'HH',
        mm: 'mm',
        endDate: 'End Date',
        save: 'Save',
        failed: 'Failed',
        failedToEdit: 'Failed to edit',
        nameRules: 'Name is required',
        descriptionRules: 'Description is required',

        votePoll: 'Poll',
        votePollSingleChoice: 'Checkbox',
        votePollMultipleChoice: 'Multiple option',
        addPoll: 'Add Poll',
        editAddPoll: 'Edit/Add Poll',
        choice: 'Options',
        choiceType: 'Option type',
        addChoice: 'Add option',
        deleteChoice: 'Delete option',
        closeTime: 'Vote closing time',
        datepickerLabel: 'Select date and time',
        datepickerClear: 'Clear',
        datepickerOk: 'Ok',
        allowAddChoice: 'Allow others to add option',
        allow: 'Allow',

        url: 'URL',
        pdf: 'PDF',
        image: 'Image',
        addContent: 'Add Content',
        noData: 'No Data',

        edit: 'Edit',
        duplicate: 'Duplicate',
        delete: 'Delete',

        addRoom: 'Add Room',

        addURL: 'Add URL',
        urlName: 'URL Title',
        title: 'Title',

        titleRules: 'Title is required',
        urlRules: 'URL is required',

        addPDF: 'Add PDF',
        fileTitle: 'File Title',
        uploadFile: 'Upload File',
        chooseFile: 'Choose File',
        sample: 'PDF Sample',

        addImage: 'Add Image',
        uploadImage: 'Upload Image',
        chooseImage: 'Choose Image',

        addQuestion: 'Add Question',
        editAddQuestion: 'Edit/Add Question',
        send: 'Send',
        score: 'Score',
        timer: 'Timer',
        minute: 'Minute',
        second: 'Second',

        answerType: 'Answer Type',
        answerText: 'Answer with Text',
        answerImage: 'Answer with Image',

        uploadImageAswer: 'Add Image Choice',
        remark:
          'The correct way to answer is to click on the radio button on the left of the answer',
        answer: 'Answer',
        addAnswer: 'Add Answer',
        deleteAnswer: 'Delete Answer',

        confirmAnswerType: 'Confirm Answer Type',
        msg1: 'Only 1 type of Answer can be selected.',
        msg2: 'Once you click Confirm, the Answer Type will be changed.',

        confirm: 'Confirm',

        confirmDelete: 'Do you want delete the question?',
        confirmDeleteInfo: 'The question will be permanently deleted',

        deleteSuccess: 'Successfully Deleted',
        deleteSuccessInfo: 'The question is successfully deleted',
        done: 'Done',

        saveSuccess: 'Successfully saved',
        saveSuccessInfo: 'The question is successfully saved',

        duplicateSuccess: 'Successfully duplicated',
        duplicateSuccessInfo: 'The question is successfully duplicated',

        scoreRules: 'Score is required',
        minuteRules: 'Minute is required',
        secondRules: 'Second is required'
      }
    },
    bundle: {
      betaMsg: 'This feature is not avaliavle in beta version. Every course is now shown as free course.',
      bundleOption: 'Pricing option',
      cancel: 'Cancel',
      confirm: 'Confirm',
      ok: 'Ok',
      done: 'Done',
      status: 'Status',
      statusAll: 'All',
      statusOn: 'On',
      statusOff: 'Off',
      optionNo: 'No',
      optionYes: 'Yes',
      optionMsg1: 'No cost is defined as the student who sees the course. You can request to join the course for free.',
      optionMsg2: 'Set costs referring to the students who see the course. Must pay for course.',
      info1: 'You can set prices for more than one bundle depending on the price. The expiration date that you set such as',
      info2: '- Able to attend classes for 30 days from the date of purchase for 500 baht.',
      info3: '- Able to attend classes until December 30, 2021 for a price of 1,000 baht regardless of when registration starts',
      warningMsg1: 'Do you want to suspend this bundle?',
      warningMsg2: 'When the sale is suspended Can come back and enable the bundle later',
      warningMsg3: 'Do you want to delete this bundle?',
      warningMsg4: 'If deleted, the data cannot be returned.',
      warningMsg5: 'Do you want to enable this bundle?',
      warningMsg6: 'Is a status change to be able to sell again',
      warningMsg7: 'Successfully Saved',
      warningMsg8: 'Can enable / suspend bundle later',
      warningMsg9: 'The bundle has been successfully saved.',
      warningMsg10: 'Successfully Deleted',
      warningMsg11: 'The data has been deleted. Cannot bring any more information back',
      warningMsg12: 'The data cannot be saved.',
      warningMsg13: 'Please check the expiration date. And time period of bundle',
      warningMsg14: 'Please check the start date of the bundle. And the end date of the bundle',
      warningMsg15: 'Please select at least one group.',
      warningMsg16: 'The bundle position cannot be suspend.',
      warningMsg17: 'Because bundle must have at least 1 bundle option.',

      headerTable: {
        image: 'Image',
        name: 'Bundle name',
        price: 'Price',
        startDate: 'Start date',
        endDate: 'End date',
        group: 'group',
        status: 'Status',
        action: 'Action',
      },
      dialogBundle: {
        headerTitile: 'Edit/Add bundle',
        close: 'Close',
        name: 'Bundle name',
        description: 'description',
        image: 'image',
        chooseFile: 'Choose file',
        bundleImage: 'File image name',
        group: 'Groups',
        groupOption: 'Group setting',
        groupOptionAll: 'All group',
        groupOptionOnly: 'Only group',
        selectGroup: 'Select group',
        durationType: 'Duration type',
        lifeLong: 'Life time',
        DateSetType: 'Date set type',
        DaySetType: 'Day set type',
        dateType: 'Date',
        date: 'Date',
        day: 'Day',
        hour: 'Hour',
        minute: 'Minute',
        status: 'Status',
        statusOn: 'On',
        statusOff: 'Off',
        startDatePublish: 'Start date publish',
        endDatePublish: 'End date publish',
        cancel: 'Cancel',
        save: 'Save',
        ok: 'Ok'
      },
    },
    exam: {
      examination: 'Examination',
      examination1: 'Examination 1',
      examination2: 'Examination 2',
      chooseExamination: 'Choose the examination',
      examinationStatus: 'Examination status',
      score: 'Score',
      seeData: 'See information',
      all: 'All',
      neverDoExamination: 'never do the examination',
      haveDoneExamination: 'have done the examination',
      examinationRecord: 'Examination record',
      noExaminationRecord: 'No examination record',
      downloadexaminationRecord: 'Download examination record',
      averageScore: 'Average score',
      OverallExamScore: 'Overall Exam Score Graph',
      YaxisXaxis: 'Y axis: score / X axis: No.',
      startTime: 'Started Date is Required',
      endTime: 'Ended Date is Required'
    },
    dialogChooseStudyingGroup: {
      groupName: 'Classroom',
      lecturerName: 'Lecturer name',
      numberStudents: 'Number of learners',
      chooseGroup: 'choose classroom'
    },
    stepCourse: {
      courseDetail: 'Course detail',
      lecture: 'Lecture',
      bundle: 'Pricing',
      live: 'Live',
      learnerManagement: 'Learner Management',
      role: 'Role',
      certificate: 'Certificate',
      whocansee: 'Accessibility',

      clickToActivate: 'Click To Activate',
      clickToSuspend: 'Click To Suspend',
      courseActivated: 'Course Activated',
      courseSuspended: 'Course Suspended',
      saveSuccess: 'Save Success',
      YouCanEditStatusLater: 'You can edit the status later.',
      ok: 'OK.',

    },
    close: 'Close',
    success: 'Success',
    dialogAddFail: {
      unsuccessfulEditing: 'Unsuccessful course editing',
      errorEditing:
        'There was an error editing the information. Please try again.'
    },
    live: {
      alertDeleteCantBringData:
        'Once this live has been deleted, it will not be able to recover the data.',
      alertDeletePdfCantBringData:
        'Once this PDF has been deleted, it will not be able to recover the data.',
      alertDeleteRoomCantBringData:
        'Once this chat room has been deleted, it will not be able to recover the data.',
      alertDeleteUrlCantBringData:
        'Once this URL has been deleted, it will not be able to recover the data.',
      alertDeleteImageCantBringData:
        'Once this image has been deleted, it will not be able to recover the data.',
      alertDeleteURLCantBringData:
        'Once this url has been deleted, it will not be able to recover the data.',
      alertDeletePDFCantBringData:
        'Once this PDF has been deleted, it will not be able to recover the data.',
      confirmStopLive: "Do you want to stop the live?",
      confirmStopLiveDetail: "Once you click Confirm, the live will be stop."
    }
  },

  userGroupManagement: {
    add: 'Add',
    option: 'More',
    changeChild: 'Change Sub Group',
    changeRoot: 'Change Parent',
    chooseGroup: 'Select Parent group',
    groupLevel1: 'Parent level 1',
    groupLevel2: 'Parent level 2',
    msg1: 'Please select new parent',
    msg2: 'Assign this group to Parent',
    edit: 'Edit',
    delete: 'Delete',
    noGroup: "No data yet. Please click \"+ Add\" button to add user groups",
    course: 'courses',
    learner: 'learners',
    addGroup: 'Add group',
    editGroupName: 'Edit Group',
    editAddGroup: 'Edit/Add Group',
    groupName: 'Group Name',
    groupNamePlH: 'Please enter the group name',
    groupNameRules: 'Please enter the group name',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    confirm: 'Confirm',
    deleteTitle: 'Would you like to delete the group?',
    deleteBody: 'Once you confirm, the group will be permanently deleted',
    deleteAlert: 'Successfully deleted',
    deleteAlertBody: 'The group is permanently deleted',
    done: 'Done',
    userGroupNotFound: 'User group not found',
  },

  categoryManagement: {
    category: 'Category',
    search: 'SEARCH',
    searchPlH: 'search category name',
    status: 'STATUS',
    all: 'All',
    on: 'On',
    off: 'Off',
    reload: 'Reload',
    addCategory: 'Add Category',

    photo: 'Photo',
    name: 'Category Name',
    createdDate: 'Created Date',
    statusHeader: 'Status',
    editCategory: 'Action',
    edit: 'Edit',
    addEditCategory: 'Add/Edit Category',
    namePlH: 'Please fill in the name of the category',
    customizePhoto: 'Upload category image',
    photoRemark: '* Remark: The best image ratio are 1:1',
    uploadPhoto: 'Upload Photo',
    choosePhoto: 'Choose photo',
    chooseNewPhoto: 'Choose new photo',
    cancel: 'Cancel',
    save: 'Save',
    categoryNameRules: "Category's Name is required",
    categoryNameRulesLimit:
      "Category's Name must be less or equal to 50 characters",

    confirmSuspend: 'Do you want to suspend?',
    suspendDetail:
      'Once the category is suspended, you are able to come back and modify the status afterward.',
    confirmActivate: 'Do you want to activate?',
    activateDetail: 'The category will be activated when you click Confirm.',

    successfullySave: 'Successfully Saved',
    canModifyLater: 'You are able to modify the status afterward',
    done: 'Done',
    confirm: 'Confirm',

    failedToSave: 'Failed to Save',
    alertDuplicatedCategory:
      'The Category Name is already chosen. Please choose another name',
    ok: 'Ok',

    failedToAdd: 'Failed to Add Category',
    errorOccured:
      'There is a problem while adding data. Please try again later.',

    successfullyAdded: 'Successfully Added',
    addingIsDone: 'The category have been successfully added',

    successfullyEdited: 'Successfully Edited',
    editingIsDone: 'The category have been successfully edited',

    sorry: 'Sorry',
    msg1: 'You are not able to use the feature because there is ',
    msg2: 'No Permission',
    msg3: ' available for this account.',

    fileRules: 'file is required',
    fileRulesSize: 'Image size should be less than 20 MB!',

    clickToSuspend: 'Click to Suspend',
    clickToActivate: 'Click to Activate',

    delete: 'Delete',
    moveToBin: 'Move to bin',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    recycleBin: 'Recycle Bin',
    tooltripClose: "Close",
    recover: "Recover",
  },

  skillManagement: {
    skill: 'Tag',
    search: 'SEARCH',
    searchPlH: 'search tag name',
    status: 'STATUS',
    all: 'All',
    on: 'On',
    off: 'Off',
    reload: 'Reload',
    addSkill: 'Add Tag',

    name: 'Tag Name',
    createdDate: 'Created Date',
    statusHeader: 'Status',
    editSkill: 'Action',
    edit: 'Edit',

    addEditSkill: 'Add/Edit Tag',
    namePlH: 'Please fill in the name of the Tag',
    cancel: 'Cancel',
    save: 'Save',
    skillNameRules: "Tag's Name is required",
    skillNameRulesLimit: "Tag's Name must be less or equal to 50 characters",

    confirmSuspend: 'Do you want to suspend?',
    suspendDetail:
      'Once the tag is suspended, you are able to come back and modify the status afterward.',
    confirmActivate: 'Do you want to activate?',
    activateDetail: 'The tag will be activated when you click Confirm.',

    successfullySave: 'Successfully Saved',
    canModifyLater: 'You are able to modify the status afterward',
    done: 'Done',
    confirm: 'Confirm',

    failedToSave: 'Failed to Save',
    alertDuplicatedSkill:
      'The tag Name is already chosen. Please choose another name',
    ok: 'Ok',

    failedToAdd: 'Failed to Add tag',
    errorOccured:
      'There is a problem while adding data. Please try again later.',

    successfullyAdded: 'Successfully Added',
    addingIsDone: 'The tag have been successfully added',

    successfullyEdited: 'Successfully Edited',
    editingIsDone: 'The tag have been successfully edited',

    sorry: 'Sorry',
    msg1: 'You are not able to use the feature because there is ',
    msg2: 'No Permission',
    msg3: ' available for this account.',

    fileRules: 'file is required',
    fileRulesSize: 'Image size should be less than 20 MB!',

    clickToSuspend: 'Click to Suspend',
    clickToActivate: 'Click to Activate',
    delete: 'Delete',
    moveToBin: 'Move to bin',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    recycleBin: 'Recycle Bin',
    tooltripClose: "Close",
    recover: "Recover",
  },

  gradeManagement: {
    level: 'Level',
    search: 'SEARCH',
    searchPlH: 'search level name',
    status: 'STATUS',
    all: 'All',
    on: 'On',
    off: 'Off',
    reload: 'Reload',
    addGrade: 'Add level',

    photo: 'Photo',
    name: 'Level Name',
    createdDate: 'Created Date',
    statusHeader: 'Status',
    editGrade: 'Action',
    edit: 'Edit',
    addEditGrade: 'Add/Edit level',
    namePlH: 'Please fill in the name of the level',
    customizePhoto: 'Customize Photo',
    photoRemark: '* Remark: The best image ratio are 16:9',
    uploadPhoto: 'Upload Photo',
    choosePhoto: 'Choose photo',
    chooseNewPhoto: 'Choose new photo',
    cancel: 'Cancel',
    save: 'Save',
    gradeNameRules: "level's Name is required",
    gradeNameRulesLimit: "level's Name must be less or equal to 50 characters",

    confirmSuspend: 'Do you want to suspend?',
    suspendDetail:
      'Once the level is suspended, you are able to come back and modify the status afterward.',
    confirmActivate: 'Do you want to activate?',
    activateDetail: 'The level will be activated when you click Confirm.',

    successfullySave: 'Successfully Saved',
    canModifyLater: 'You are able to modify the status afterward',
    done: 'Done',
    confirm: 'Confirm',

    failedToSave: 'Failed to Save',
    alertDuplicatedGrade:
      'The level Name is already chosen. Please choose another name',
    ok: 'Ok',

    failedToAdd: 'Failed to Add level',
    errorOccured:
      'There is a problem while adding data. Please try again later.',

    successfullyAdded: 'Successfully Added',
    addingIsDone: 'The level have been successfully added',

    successfullyEdited: 'Successfully Edited',
    editingIsDone: 'The level have been successfully edited',

    sorry: 'Sorry',
    msg1: 'You are not able to use the feature because there is ',
    msg2: 'No Permission',
    msg3: ' available for this account.',

    fileRules: 'file is required',
    fileRulesSize: 'Image size should be less than 20 MB!',

    clickToSuspend: 'Click to Suspend',
    clickToActivate: 'Click to Activate',
    delete: 'Delete',
    moveToBin: 'Move to bin',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    recycleBin: 'Recycle Bin',
    tooltripClose: "Close",
    recover: "Recover",
  },

  bannerManagement: {
    banner: 'Banner',
    search: 'Search',
    searchPlH: 'Search banner name',
    status: 'Status',
    all: 'All',
    on: 'On',
    off: 'Off',
    reload: 'Reload',
    addBanner: 'Add Banner',
    clickToSuspend: 'Click to Suspend',
    clickToActivate: 'Click to Activate',
    edit: 'Edit',
    addEditBanner: 'Add/Edit Banner',
    name: 'Banner Name',
    namePlH: 'Please fill in the name of the banner',
    url: 'URL',
    urlPlH: 'Please fill in the URL',
    customizePhoto: 'Customize Photo',
    photoRemark: '* Remark: The best image ratio are 16:9',
    uploadPhoto: 'Upload Photo',
    choosePhoto: 'Choose photo',
    chooseNewPhoto: 'Choose new photo',
    cancel: 'Cancel',
    save: 'Save',
    confirm: 'Confirm',
    successfullyAdded: 'Successfully Added',
    addingIsDone: 'The banner have been successfully added',
    successfullyEdited: 'Successfully Edited',
    editingIsDone: 'The banner have been successfully edited',
    fileRules: 'file is required',
    fileRulesSize: 'Image size should be less than 20 MB!',
    bannerNameRules: "Banner's Name is required",
    bannerNameRulesLimit:
      "Banner's Name must be less or equal to 100 characters",
    urlNameRules: 'URL is required',
    urlNameRulesLimit: 'URL must be less or equal to 200 characters',
    photo: 'Photo',
    createdDate: 'Created Date',
    statusHeader: 'Status',
    editBanner: 'Edit banner',
    action: 'Action',
    delete: 'Delete',
    moveToBin: 'Move to bin',
    confirmUnpublish: 'Do you want to suspend the publication of this banner?',
    unpublishDescript:
      'Once the banner is suspended, you can come back to publish afterward.',
    confirmPublish: 'Do you want to publish this banner?',
    publishDescript: 'Once the banner is publish, learner can see this banner.',
    successfullySave: 'Successfully Saved',
    canModifyLater: 'You are able to modify the permission afterward',
    done: 'Done',
    confirmDeleteItem: 'Are you sure you want to delete this item?',
    bannerOrdering: 'Banner Ordering',
    tooltripClose: 'Close',
    dragToMoveSequence: 'Drag to re-order',
    recycleBin: 'Recycle Bin',
    recover: 'Recover',
    group: 'Groups',
    selectGroup: 'Select Group',
  },

  eventManagement: {
    eventManagement: 'Event Management',
    recycleBin: 'Recycle Bin',
    createEvent: 'New Event',
    search: 'Search',
    searchEvent: 'Search event name',
    status: 'Status',
    statusAll: 'All',
    statusOn: 'On',
    statusOff: 'Off',
    reload: 'Reload',
    edit: 'Edit',
    delete: 'Delete',
    confirmSuspend: 'Do you want to suspend?',
    suspendDetail:
      'Once the event is suspended, you are able to come back and modify the status afterward.',
    confirmActivate: 'Do you want to activate?',
    activateDetail: 'The event will be activated when you click Confirm.',
    confirm: 'Confirm',
    moving: 'Moving',
    successfullySave: 'Successfully Saved',
    canModifyLater: 'You are able to modify the status afterward',
    done: 'Done',
    header: {
      photo: 'Photo',
      eventName: 'Event Name',
      detail: 'Detail',
      type: 'Type Of Event',
      startTime: 'Start Time',
      endTime: 'End Time',
      alert: 'Notifications',
      status: 'Status',
    },
    time: 'Time',
    sent: 'Sent',
    sentFail: 'Sent Failed',
    notSend: 'Not sending',
    type: {
      course: 'Course',
      live: 'Live',
      exam: 'Exam',
      link: 'URL',
      general: 'General',
    },
    addEditEvent: 'Add/Edit Event',
    chooseCourse: 'Select Course',
    chooseLive: 'Select Live',
    chooseExam: 'Select Exam',
    chooseUserGroup: 'Select User group',
    eventName: 'Event Name',
    link: 'URL',
    detail: 'Detail',
    image: 'Photo',
    chooseFile: 'Choose File',
    warning: 'Warning!',
    recover: 'Recover',
    msg: {
      msg1: 'Acceptable formats：.png .jpg only',
      msg2: 'Are you sure you want to delete this item?',
      msg3: 'Once this event has been deleted, it will not be able to recover the data.',
      msg4: 'After the event item has been moved to the bin The event list will be stopped automatically. And the notification will not be sent at the scheduled time.',
      msg5: 'Do you want to recover the items of the selected event from the bin?',
      msg6: 'When the event item is recover from the bin Will be able to edit information immediately If the time limit has been exceeded, the notification cannot be edited.',
      msg7: 'The event has been recovered.',
      msg8: 'This event has been successfully moved to the event table.',
    },
    target: 'Target',
    allOrganization: 'All in organization',
    courseUsergroup: 'Course Or User group',
    platform: 'Platform',
    allPlatform: 'All Platform',
    ios: 'iOS',
    android: 'Android',
    timeEvent: 'Schedule Event',
    eventStartTime: 'Start Time',
    eventEndTime: 'End Time',
    alert: 'Notifications',
    notSending: 'Not Sending Notifications',
    sendNow: 'Send Now',
    sendOnEventTime: 'Sent With Event Time',
    customTime: 'Custom',
    selectDate: 'Select date-time',
    cancel: 'Cancel',
    save: 'Save',
    send: 'Send now',
    ok: 'Ok',
  },

  dontHavePermisisonLong:
    'You are not able to use this function because your account does not have the permission.',
  dontHavePermisison:
    'You are not able to use this function because your account does not have ',
  permission: 'the permission.',
  reachAccount: 'การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ',
  registerTeacher: 'Register to be a tutor',
  requestTeacher: 'To access to this item, please register to be a tutor',
  requestTeacherAgain:
    'To access to this item, please <strong>register to be a tutor again.</strong>',
  // requestTeacher: 'Register to be a tutor',
  courseName: 'Course name',
  courseNameTh: 'Course name Thai',
  courseNameEng: 'Course name English',
  courseDescription: 'Course description',
  courseNameRule: 'Please enter the course name',
  courseNameEngRule: 'Please enter the english course name',
  level: 'Level',
  tag: 'Tag',
  category: 'Category',
  trade: 'Bundles',
  duration: 'Duration Type',
  pricing: 'Price',
  day: 'Day',
  date: 'Date',
  skill: 'Tag',
  chooseLevel: 'Choose level',
  chooseTag: 'Choose tag',
  chooseCategory: 'Choose category',
  choosePurchasing: 'Choose purchasing',
  chooseDuration: 'Choose duration type',
  choosePrice: 'Price is required',
  typeDay: 'Day is required',
  chooseSkill: 'Choose tag',
  studyingType: 'Studying type',
  myself: 'Myself',
  otherInstructor: 'Other',
  setOwner: 'Set owner',
  setAdmins: 'Admins',
  showCreator: 'Creator',
  chooseInstructor: 'Search Instructor',
  independentStudy: 'Independent study',
  sequentlyStudy: 'Sequently study',
  discussionBoard: 'Discussion board',
  enable: 'Enable',
  disable: 'Disable',
  sendDirect: 'Send direct message to tutor',
  courseCover: 'Course cover photo',
  chooseCourseCover: 'Choose course cover photo',

  infoToMyCourse: 'To go back to "Course Management", tap on the',
  infoCourseList: '"Course List" button',
  infoCreateCourse: 'To create the lecture, ',
  orOnTap: 'or',
  infoLecture: '"Lecture"',
  top: 'tab above',

  create: ' Create Course',
  btnCourseList: 'Back to course management',

  // Live
  liveName: 'Live Name',
  liveDescription: 'Live description',
  Date: 'Date',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  liveType: 'ประเภทของการถ่ายทอดสด',
  liveTypebyMyself: 'ถ่ายทอดสดด้วยตัวเอง',
  liveTypebyVideo: 'ถ่ายทอดสดด้วยวิดีโอที่เตรียมไว้',
  // alert
  plsUploadPhoto: 'Please upload photo.',
  plsChooseCategory: 'Please select category.',
  plsChooseTrade: 'Please select purchasing.',
  plsChooseDurationType: 'Please select duration type.',
  plsChooseSkill: 'Please choose tags.',
  plsChooseUnder20MB: 'Please choose a file with the size under 20 MB.',
  plsEnterAllData: 'Please enter all data.',
  plsChooseFile: 'Please choose a file.',
  plsChooseLevel: 'Please choose level.',

  averageScore: 'Average score',
  No: 'No.',
  // profile
  pic: 'Photo',
  role: 'Role',
  joinedBy: 'Joined By',
  expiration: 'Expiration',
  active: 'Active',
  profilePic: 'Profile picture',
  fullName: 'Full name',
  progress: 'Progress',
  email: 'Email',
  username: 'Username',
  room: 'Room',
  report: 'Report',
  studentInformation: 'Learner information',

  companyManagement: {
    updateSuccess: 'Successfully saved',
    updateInfoSuccess: "The company's detail is successfully saved"
  }
};
